import Vue from 'vue'

Vue.filter('bgImage', function (value) {
  return value && 'background-image: url(' + value + ');'
})
